import { authGet } from "@api/auth/auth";
import { AUTH_URL } from "@constants";
import { AuthProvider } from "@types";

export const fetchSsoProvider = (ssoEmail: string): Promise<AuthProvider> => {
  return authGet<AuthProvider>(
    `${AUTH_URL}/sso?email=${encodeURIComponent(ssoEmail)}`
  );
};
